<template>
  <div class="MyMessage div-layout">
    <module-title title="通知">
      <div class="right">
        <el-button
          type="primary"
          size="medium"
          icon="el-icon-position"
          @click="opAddOrEdit('add')"
        >
          发布通知
        </el-button>
      </div>
    </module-title>
    <!-- <h3 class="title">消息列表</h3> -->
    <!-- 消息列表 -->
    <el-form
      ref="subjectSearchForm"
      :model="searchForm"
      :inline="true"
      label-position="right"
      label-width="100px"
    >
      <el-form-item label="标题：" prop="title">
        <el-input
          v-model="searchForm.title"
          name="title"
          placeholder="请输入标题"
          class="handle-form-input"
        />
      </el-form-item>
      <el-form-item label="推送终端：" prop="name">
        <el-select
          v-model="searchForm.dictsType.code"
          name="Terminal"
          size="medium"
          class="edit-form-input"
          @change="getTerminal"
        >
          <el-option
            v-for="item in terminaltypeArr"
            v-show="item.code === 'C01' || item.code === 'A02' || item.name === '全部'"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          />
        </el-select>
      </el-form-item>

      <el-form-item style="margin-left:50px;">
        <el-button type="primary" size="medium" icon="el-icon-search" @click="handleSearchFilter">
          查询
        </el-button>
      </el-form-item>
    </el-form>
    <!-- <multiple-box :visible="isSelection" :selection-num="selectionNum">
      <span class="handle-span" @click="handleSign($event,1)">批量启用</span>
      <span class="handle-span" @click="handleSign($event,0)">批量禁用</span>
    </multiple-box>-->
    <el-table
      v-loading="listLoading"
      :data="myMessageList"
      element-loading-text="Loading"
      class="list-table"
    >
      <!-- <el-table-column type="selection" width="55" align="center" /> -->
      <el-table-column type="index" width="55" align="center" label="序号" />
      <el-table-column label="通知标题" align="center" prop="title" />
      <el-table-column label="推送终端" prop="desTerminalName" align="center" />
      <el-table-column label="发布人" align="center" prop="userName" />
      <el-table-column label="发布状态" align="center" prop="isPush">
        <template slot-scope="scope">
          <span class="status" :class="[scope.row.isPush===1?'link':'unlink']" />
          {{ scope.row.isPush===1?'已发布':'未发布' }}
        </template>
      </el-table-column>
      <el-table-column label="发布时间" align="center" prop="pubDate" width="158px" />
      <el-table-column label="操作" align="center" width="210px">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="small"
            icon="el-icon-view"
            @click="opAddOrEdit('view',scope.row)"
          >
            查看
          </el-button>
          <el-button
            v-show="scope.row.isPush===0"
            type="danger"
            size="small"
            icon="el-icon-position"
            @click="opAddOrUpdate(scope.row)"
          >
            发布
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <pagination
        :total="searchForm.total"
        :page.sync="searchForm.pageNum"
        :limit.sync="searchForm.pageSize"
        @pagination="pageCurriculumList"
        @handleSizeChange="handleSizeChange"
      />
    </div>

    <!-- 通知详情弹框start -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="hiddenVariable.dialogViewVisible"
      :title="handleDialog.handleTitle"
      width="960px"
    >
      <ViewDialog
        v-if="hiddenVariable.dialogViewVisible"
        :content="content"
        :dialog-type="handleDialog.type"
        @closeDialog="hiddenVariable.dialogViewVisible = false"
        @handleAddNotice="handleAddNotice"
      />
    </el-dialog>

    <!-- 通知详情弹框end -->
  </div>
</template>

<script>
import ViewDialog from './viewDialog.vue';

//
// 获取API
import {
  getDictsType,
  getNoticeInfos,
  // getMyMessageStatus,
  // ReleaseNotices,
  getNoticesStatus
} from '@/api/productOperation/mrDesk/myMessage';
import { mapGetters } from 'vuex';
export default {
  name: 'NoticeManage',
  components: {
    ViewDialog
    // MultipleBox
  },
  data() {
    return {
      searchForm: {
        id: '',
        dictsType: {
          code: '',
          name: ''
        },
        // organization: '',
        title: '',
        sourceTerminalCode: 'A04',
        pageNum: 1,
        total: 0,
        pageSize: 10
      },

      listLoading: false,

      handleDialog: {
        type: 'add',
        handleTitle: ''
      },
      active: 0,
      hiddenVariable: {
        // 详情
        dialogViewVisible: false
      },
      dictsType: 'terminal_type',
      // multipleSelection: [], // 表格多选,
      myMessageList: [],
      terminaltypeArr: [],
      // organizationArr: [],
      content: null
    };
  },
  mounted() {
    this.getType();
  },
  computed: {
    // // 是否多选
    // isSelection() {
    //   return this.multipleSelection.length > 0;
    // },
    // // 多选数量
    // selectionNum() {
    //   return this.multipleSelection.length;
    // }
    ...mapGetters(['userInfo', 'currentProdeuctId'])
  },
  methods: {
    // 获取反馈类型列表
    getType() {
      getDictsType(this.dictsType).then(res => {
        this.terminaltypeArr = res.data;
        this.terminaltypeArr.unshift({
          name: '全部',
          code: ''
        });
        this.searchForm.dictsType.name = res.data[0].code;
        this.searchForm.dictsType.code = res.data[0].code;
        this.listLoading = true;
        this.getInfoList();
      });
    },
    // 获取列表
    getInfoList() {
      getNoticeInfos({
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize,
        desTerminalCode: this.searchForm.dictsType.code,
        productId: this.currentProdeuctId,
        sourceTerminalCode: this.searchForm.sourceTerminalCode,
        // orgCode: this.userInfo.orgCode,
        firstTypeCode: 1,
        sendCode: this.userInfo.code,
        title: this.searchForm.title
      })
        .then(res => {
          this.listLoading = false;
          if (res.data === null || res.data === '' || res.data === 'undefind') {
            this.myMessageList = [];
            this.searchForm.total = 0;
          } else {
            this.myMessageList = res.data.list;
            this.searchForm.total = res.data.total;
          }
        })
        .catch(err => {
          this.$message({
            type: 'warning',
            message: '暂无数据'
          });
          this.listLoading = false;
          console.log(err);
        });
    },
    // 表格选择事件
    // handleSelectionChange(val) {
    //   this.multipleSelection = val;
    // },

    // handleSign(row, value) {
    //   let noticeIds = [];
    //   const status = value;
    //   let text = '';
    //   if (value === 0) {
    //     text = '未读';
    //   } else if (value === 1) {
    //     text = '已读';
    //   } else {
    //     text = '删除';
    //   }
    //   if (this.multipleSelection.length > 0) {
    //     noticeIds = this.multipleSelection.map(x => x.id);
    //   } else {
    //     noticeIds.push(row.id);
    //   }
    //   this.$confirm(
    //     `确定要标记${
    //       this.multipleSelection.length > 0 ? '所选' : '该条'
    //     }为${text}?`,
    //     '提示',
    //     {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     }
    //   )
    //     .then(() => {
    //       var option = {
    //         ids: noticeIds,
    //         status: status
    //       };
    //       getMyMessageStatus(option).then(res => {
    //         this.listLoading = true;
    //         this.getInfoList();
    //       });
    //     })
    //     .catch(() => {});
    // },
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.listLoading = true;
      this.getInfoList();
    },
    getTerminal(val) {
      this.searchForm.terminal = val;
    },
    // getorganization(val) {
    //   this.searchForm.organization = val;
    // },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.listLoading = true;
      this.getInfoList();
    },

    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.listLoading = true;
      this.getInfoList();
    },

    opAddOrEdit(type, val) {
      if (val) {
        this.content = val;
      }
      this.handleDialog.type = type;
      this.handleDialog.handleTitle = type === 'add' ? '发布通知' : '查看通知';
      this.hiddenVariable.dialogViewVisible = true;
    },
    opAddOrUpdate(row) {
      var option = {
        isPush: 1
      };
      getNoticesStatus(option, row.id).then(res => {
        this.listLoading = true;
        this.getInfoList();
      });
    },
    // 新增编辑学科
    handleAddNotice() {
      this.hiddenVariable.dialogViewVisible = false;
      this.listLoading = true;
      this.getInfoList();
    }
  }
};
</script>
<style lang="scss" scoped>
.MyMessage {
  .terminaltypeArr {
    margin-bottom: 20px;
    margin-left: 10px;
    ul {
      padding: 0;
      margin: 0;
      height: 52px;
      line-height: 52px;
      li {
        display: inline;
        padding: 8px 30px;
        border: #e2e2e2 1px solid;
        margin: 10px;
        border-radius: 4px;
      }
      li.active {
        color: #fff;
        font-weight: bold;
        background: #409eff;
        border: #409eff 1px solid;
      }
    }
  }
  .title {
    border-left: 5px solid #1890ff;
    margin-left: 20px;
    padding-left: 10px;
  }
  .urllink {
    cursor: pointer;
    color: #409eff;
    text-decoration: underline;
  }
  .status {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 2px;
    vertical-align: middle;
  }
  .link {
    background: #41ad01;
  }
  .unlink {
    background: orange;
  }
}
</style>
